import { BaseNode } from './base/BaseNode';

export class Blockquote extends BaseNode {
  constructor() {
    super('blockquote');
  }

  get schema() {
    return {
      content: 'block+',
      group: 'block',
      defining: true,
      parseDOM: [{ tag: 'blockquote' }],
      toDOM() {
        return ['blockquote', 0] as const;
      },
    };
  }
}
